'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { cn } from '../../utils/cn';
import { inputTheme } from './theme';
export const Input = forwardRef(({ className, type = 'text', placeholder, ...props }, ref) => {
    return (_jsx("input", { ref: ref, ...props, type: type, placeholder: placeholder, className: cn(inputTheme.input, className) }));
});
Input.displayName = 'Input';
